import {useState} from 'react';

export type ICookieOptions = {
  days?: number;
  path?: string;
  domain?: string;
};

const defaultOptions: ICookieOptions = {
  days: 30,
  path: '/',
};

const setCookie = <T>(name: string, value: T, options: ICookieOptions = defaultOptions) => {
  options = {
    ...defaultOptions,
    ...options,
  };

  const expires = new Date(Date.now() + options.days * 86400000).toUTCString();

  let cookieValue = typeof value === 'object' ? JSON.stringify(value) : value.toString();

  document.cookie = name + '=' + encodeURIComponent(cookieValue)
    + ';expires=' + expires + ';'
    + (options.domain ? `domain=${options.domain};` : '')
    + 'path=' + options.path;
};

const getCookie = <T>(name: string): T => {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    if (parts[0] === name) {
      const rawVal = decodeURIComponent(parts[1]);
      try {
        return JSON.parse(rawVal);
      } catch (e) {
        return rawVal;
      }
    }
    return r;
  }, '');
};

const deleteCookie = (name: string) => {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}

const useCookie = function <T>(key: string, initialValue: T = null) {
  const [item, setItem] = useState<T>(() => {
    return getCookie(key) || initialValue;
  });

  const updateItem = (value: T, options: ICookieOptions) => {
    setItem(value);
    setCookie(key, value, options);
  };

  return [item, updateItem];
};

export {setCookie, getCookie, deleteCookie};
export default useCookie;
